import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vision-home',
  templateUrl: './vision-home.component.html',
  styleUrls: ['./vision-home.component.scss']
})
export class VisionHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
